import { To } from "react-router-dom-v5-compat";

import { Box, Button, Link } from "@seneca/senekit";

import ControlledTextInput from "seneca-common/utils/form-hook/inputs/ControlledTextInput";
import { validateControlledEmailStrictly } from "seneca-common/utils/form-hook/utils/validationFunctions";
import { validatePasswordBasic } from "seneca-common/utils/functions/validation/password";

import { isMobile } from "features/common/utils/functions/mobile";

export function SignInSubmitButton({
  onSubmit,
  loading,
  children = "Log in"
}: {
  onSubmit: () => void;
  loading: boolean;
  children?: React.ReactNode;
}) {
  return (
    <Button onClick={onSubmit} loading={loading} width="100%">
      {children}
    </Button>
  );
}

export function SignInWithEmailLinkButton({
  onSubmit,
  loading
}: {
  onSubmit: () => void;
  loading: boolean;
}) {
  return (
    <Button onClick={onSubmit} loading={loading} width="100%">
      Send one-time email link
    </Button>
  );
}

export function SignInEmailInput({
  email,
  autoFocus,
  onEnterKeyPress
}: {
  email?: string;
  autoFocus?: boolean;
  onEnterKeyPress?: () => void;
}) {
  return (
    <Box flex="1">
      <ControlledTextInput
        name="email"
        label="Email"
        type="email"
        autoFocus={!isMobile() && autoFocus}
        defaultValue={email}
        validateObj={validateControlledEmailStrictly}
        onEnterKeyPress={onEnterKeyPress}
      />
    </Box>
  );
}

export function SignInPasswordInput({
  autoFocus,
  onEnterKeyPress,
  placeholderText,
  isOptional
}: {
  autoFocus?: boolean;
  onEnterKeyPress?: () => void;
  placeholderText?: string;
  isOptional?: boolean;
}) {
  return (
    <Box flex="1">
      <ControlledTextInput
        name="password"
        label="Password"
        type="password"
        placeholder={placeholderText}
        autoFocus={!isMobile() && autoFocus}
        validateObj={isOptional ? undefined : validatePasswordBasic}
        onEnterKeyPress={onEnterKeyPress}
      />
    </Box>
  );
}

export function ForgotPasswordLink({
  forgotPasswordLink
}: {
  forgotPasswordLink: To;
}) {
  return (
    <Link size="small" to={forgotPasswordLink}>
      Forgot your password?
    </Link>
  );
}
